import get from "lodash/get";

const ErrorHandler = (error, formApi = null, controlPanelActions, dispatch = null) => {
	const errors = get(error, "response.data.Errors");
	const message = get(error, "response.data.Message");
	let otherErrors = [];
	if (errors) {
		errors.forEach(error => {
			if (formApi && formApi.fieldExists(error.Key)) {
				formApi.setError(error.Key, error.Value);
			} else {
				otherErrors.push(error.Value);
			}
		});
	} else if (message) {
		if (dispatch) {
			dispatch(controlPanelActions.displayError(message));
		} else {
			controlPanelActions.displayError(message);
		}
	}
	if (otherErrors.length > 0) {
		if (dispatch) {
			dispatch(controlPanelActions.displayError(otherErrors.join(" - ")));
		} else {
			controlPanelActions.displayError(otherErrors.join(" - "));
		}
	}
};

export default ErrorHandler;
